import React, { Component } from "react";
import { Link } from "react-router-dom";
import Spinner from "../Spinner/Spinner";

class PaymentSuccessful extends Component {
  handlePush = () => {
    this.props.history.push({
      pathname: "/myOrders",
    });
  };

  render() {
    const { result } = this.props;

    return (
      <>
        <>
          <div className="HeadPay">
            <span>پرداخت</span>
            <Link to="/mainPage">&#10005;</Link>
          </div>
          {result === "success" ? (
            <div className="paymentDiv">
              <div className="paymentDivBody">
                <div className="Img">
                  <img
                    src="/public/assets/icons/Group 1000001309.svg"
                    alt="warning"
                  />
                </div>
                {result === "success" ? (
                  <span className="TextSuccessful">
                    پرداخت شما با موفقیت انجام گرفت
                  </span>
                ) : (
                  <span className="TextSuccessful">خرید شما ناموفق بود </span>
                )}

                <div className="Content">
                  <div className="Bottom">
                    <span className="TrackingCode">هزینه پرداخت شده:</span>
                    <span className="Numbers">
                      {this.props?.price?.toLocaleString()} تومان
                    </span>
                  </div>
                </div>
              </div>
              <div className="paymentFooter">
                <Link to={"/profile/myOrders"}>
                  <button className="OrderFactor">مشاهده سفارش</button>
                </Link>
              </div>
            </div>
          ) : (
            <>
              <div className="paymentDiv">
                <div className="paymentDivBody">
                  <div className="Img">
                    <img
                      src="/public/assets/icons/warning1.svg"
                      alt="warning"
                    />
                  </div>
                  <span className="TextWarninig">
                    متاسفانه پرداخت شما انجام نگرفت
                  </span>

                  {/* <div className="Content">
                    <div className="Bottom">
                      <span className="TrackingCode">هزینه پرداخت شده:</span>
                      <span className="Numbers">
                        {this.props?.price?.toLocaleString()} تومان
                      </span>
                    </div>
                  </div> */}
                </div>
                <div className="paymentFooter">
                  {/* <button className="Support">تماس با پشتیبانی</button> */}
                    <Link to={"/profile/myOrders"} className="viewOrder">
                      <button className="OrderFactor viewOrder">مشاهده سفارش</button>
                    </Link>
                </div>
              </div>
            </>
          )}
        </>
      </>
    );
  }
}

export default PaymentSuccessful;
